import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as DashboardRoute from "./dashboard";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// The shell only. Workflows — the section this service exists for — arrive with
// the entity itself; until then the root lands on the dashboard, which is what
// the sign-in flow already points at.
const RootRoute = () => <Redirect to={`/dashboard`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"Repoflow Workflows"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                },
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/dashboard`} component={DashboardRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
